import { UploadOutlined } from '@ant-design/icons'
import { FormCard, FormItem } from '@lmc/ui-kit'
import { Button, Text } from '@lmc/ui-kit/src/general'
import Divider from '@lmc/ui-kit/src/layout/Divider/Divider'
import { Switch, Upload } from 'antd'
import { NAMESPACE } from 'locale'
import type React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type AdditionalDetailsSectionProps = {
  showAdditionalDetails: boolean
  onToggle: (checked: boolean) => void
  fileList: any[]
  onFileChange: (info: any) => void
  children?: React.ReactNode
}

const AdditionalDetailsSection = ({
  showAdditionalDetails,
  onToggle,
  fileList,
  onFileChange,
  children
}: AdditionalDetailsSectionProps) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)

  return (
    <FormCard level={2}>
      <SwitchContainer>
        <Switch
          checked={showAdditionalDetails}
          onChange={onToggle}
          data-testid="additional-details-switch"
        />
        <SwitchLabel>{t('ADDITIONAL_DETAILS')}</SwitchLabel>
      </SwitchContainer>

      {showAdditionalDetails && (
        <>
          <Divider />
          <FormItem name="media" label={<Text>{t('MEDIA')}</Text>} full>
            <Upload
              fileList={fileList}
              listType="picture"
              onChange={onFileChange}
              beforeUpload={() => false}
              multiple
            >
              <Button>
                <UploadOutlined />
                {t('CLICK_TO_UPLOAD')}
              </Button>
            </Upload>
          </FormItem>
          {children}
        </>
      )}
    </FormCard>
  )
}

const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const SwitchLabel = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color4};
`

export default AdditionalDetailsSection
